import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=1c4eb3f8"
import script from "./ProfileDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileDropdown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports